import { render, staticRenderFns } from "./SubCategoryList.vue?vue&type=template&id=287ea849"
import script from "./SubCategoryList.vue?vue&type=script&lang=js"
export * from "./SubCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports